// src/utils/competitionLevels.js
export const COMPETITION_LEVELS = [
  { key: "recreational", label: "Recreational" },
  { key: "competitive", label: "Competitive" },
  { key: "elite", label: "Elite" },
  { key: "open", label: "Open" },
  { key: "beginner", label: "Beginner"},
  { key: "intermediate", label: "Intermediate"},
  { key: "advance", label: "Advance"},
];
